import { JsonObject, JsonProperty } from 'json2typescript';
import SubQuestion from '@/models/entry/SubQuestion';
import Question from '@/models/entry/Question';
import Choice from '@/models/entry/Choice';

@JsonObject('ModelAnswer')
export default class ModelAnswer {
  constructor() {
    this.questionCode = '';
    this.passFail = '';
    this.modelAnswer = '';
    this.evaluationCode = '';
    this.evaluationTitle = '';
    this.question = new Question();
    this.subQuestions = [];
    this.answerChoices = [];
    this.correctChoices = [];
    this.questionNumber = 0;
  }

  @JsonProperty('question_code')
  public questionCode: string;

  @JsonProperty('pass_fail')
  public passFail: string;

  @JsonProperty('model_answer')
  public modelAnswer: string;

  @JsonProperty('evaluation_code')
  public evaluationCode: string;

  @JsonProperty('evaluation_title')
  public evaluationTitle: string;

  @JsonProperty('question', Question, false)
  public question: Question;

  @JsonProperty('sub_questions', [SubQuestion], true)
  public subQuestions: SubQuestion[];

  @JsonProperty('answer_choices', [Choice], true)
  public answerChoices: Choice[];

  @JsonProperty('correct_choices', [Choice], true)
  public correctChoices: Choice[];

  /**
   * 問題番号
   */
  public questionNumber: number;
}
